<div
  class="payment-schedule-picker"
  [class.payment-schedule-picker--disabled]="disabled"
>
  @for (option of options; track option.productCode) {
    <div
      class="payment-schedule-picker__option"
      [class.payment-schedule-picker__option--selected]="isSelected(option)"
    >
      <button
        type="button"
        class="payment-schedule-picker__selectable"
        [disabled]="disabled"
        [attr.aria-pressed]="isSelected(option)"
        (click)="selectOption(option.productCode)"
      >
        <span class="payment-schedule-picker__radio" aria-hidden="true">
          <span class="payment-schedule-picker__radio-dot"></span>
        </span>
        <span class="payment-schedule-picker__content">
          <span class="payment-schedule-picker__header">
            <span class="payment-schedule-picker__title-col">
              <span class="payment-schedule-picker__title">{{
                option.title
              }}</span>
              <span class="payment-schedule-picker__description">{{
                getOptionDescription(option)
              }}</span>
            </span>
            <span class="payment-schedule-picker__price-col">
              @if (
                option.scheduleType === 'annual' && option.monthlyPrice != null
              ) {
                <span class="payment-schedule-picker__price">
                  <span
                    class="payment-schedule-picker__currency tw-uppercase"
                    >{{ option.currencyCode }}</span
                  >
                  <span class="payment-schedule-picker__amount">{{
                    getAmountPerMonth(option)
                      | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span>
                  <span class="payment-schedule-picker__per">/mo</span>
                </span>
                @if (option.annualSavings != null) {
                  <span class="payment-schedule-picker__savings">
                    Save
                    {{
                      formatMoney(getAnnualSavings(option), option.currencyCode)
                    }}
                    /yr
                  </span>
                }
              } @else if (
                option.scheduleType === 'one-time' &&
                option.oneTimePrice != null
              ) {
                <span
                  class="payment-schedule-picker__amount payment-schedule-picker__amount--solo"
                  >{{
                    option.oneTimePrice | currency: 'USD' : 'symbol' : '1.2-2'
                  }}</span
                >
              }
            </span>
          </span>
          @if (
            option.scheduleType === 'annual' &&
            option.newMonthlyTotalCredits != null
          ) {
            <span class="payment-schedule-picker__footer">
              <span class="payment-schedule-picker__footer-label"
                >New Monthly total</span
              >
              <span class="payment-schedule-picker__footer-value"
                >{{ option.newMonthlyTotalCredits }} credits</span
              >
            </span>
          }
        </span>
      </button>
      @if (option.scheduleType === 'annual' && option.existingSubscription) {
        <div class="payment-schedule-picker__existing-alert">
          <p class="payment-schedule-picker__existing-message">
            <strong>You already have an AI Credit annual subscription: </strong>
            To continue to use AI features, add more credits to your current
            subscription.
          </p>
          <a
            class="btn btn-primary payment-schedule-picker__modify-btn"
            uiSref="apps.purchase.licenses.add-additional-ai-credits"
            [uiParams]="{ subscriptionId: option.existingSubscription }"
            >Modify My Subscription</a
          >
        </div>
      }
    </div>
  }
</div>
